import { render } from "./AccountMoney.vue?vue&type=template&id=44f2e086"
import script from "./AccountMoney.vue?vue&type=script&lang=js"
export * from "./AccountMoney.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__